import type {
  VastuRoomInput,
  VastuAnalyzeRequest,
  VastuRoomResult,
  VastuAnalyzeResponse,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { VastuRoomInput, VastuAnalyzeRequest, VastuRoomResult, VastuAnalyzeResponse };

export async function analyzeVastu(data: VastuAnalyzeRequest): Promise<VastuAnalyzeResponse> {
  return apiRequest<VastuAnalyzeResponse>(
    "/vastu/analyze",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    20_000,
  );
}
